/**
 * @param url 需要预览的文件地址
 *
 * @export
 */
export default function () {
  return {
    url: null,
  };
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxOffice/param.js